//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';

import { InReviewBadge } from '@components/molecules/in-review-badge/InReviewBadge';
import makeAngularReactController from '@react-bridge/angular-react-widget';

angular.module('curalate').component('universalImageActionsInReviewBadge', {
  controller: makeAngularReactController(<InReviewBadge />),
});
